import { Antd_Global_Theme, Antd_PrefixCls } from '@/constants/index'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import ReissueRecordsModal from './ReissueRecordsModal'

function withHOC(WrappedComponent: React.FC<any>) {
	return function WithHOC(props: any) {
		return (
			<ConfigProvider locale={zhCN} prefixCls={Antd_PrefixCls} theme={Antd_Global_Theme}>
				<WrappedComponent {...props} />
			</ConfigProvider>
		)
	}
}
const OldAppComponents = {
	ReissueRecordsModal: withHOC(ReissueRecordsModal),
}
export default OldAppComponents
